import React, { useState, useRef } from 'react';
import {
  Box,
  Container,
  Typography,
  Grid,
  Paper,
  Button,
  Stepper,
  Step,
  StepLabel,
  StepContent,
  Stack,
  Divider,
  useTheme,
  useMediaQuery
} from '@mui/material';
import { ClinicalTrialsSignupCard } from './ClinicalTrialsSignupCard';
import { ClinicalTrialsSignupForm } from './ClinicalTrialsSignupForm';
import { HowProcessWorks } from './HowProcessWorks';
import { AboutMassiveBio } from './AboutMassiveBio';
import { ConfirmationCard } from './ConfirmationCard';
// import { styled } from '@mui/system'; // Removed styled
import Certifications from './certifications.png'; // Added import statement
import { YouTubeContent1 } from '../resources/YouTubeContent';
import ClinicalTrialsBenefits from './ClinicalTrialsBenefits';
import { DrArturoExplains } from './DrArturoExplains';
import { FAQ } from './FAQ';
import { NewMultipleMyelomaOptions } from './NewMultipleMyelomaOptions';
import { Block } from '@mui/icons-material';
//import { createTheme, responsiveFontSizes } from '@mui/material/styles';
interface ProcessStep {
  label: string;
  description: string;
}

// Replaced styled components with sx prop
const ImageWrapper = ({ children, ...props }: any) => <Box {...props}>{children}</Box>;


const ResponsiveImage = ({ ...props }: any) => <img {...props} />;


export const ClinicalTrialsInfo: React.FC = () => {
  const [submitted, setSubmitted] = React.useState(false);
  const theme = useTheme();
  const isMdUp = useMediaQuery(theme.breakpoints.up('md'));
  const scrollToTitleRef = useRef<HTMLDivElement>(null);
  const BoxBelowTitleRef = useRef<HTMLDivElement>(null);

  React.useEffect(() => {
    if (BoxBelowTitleRef.current) {
      console.log('Scroll Height:', BoxBelowTitleRef.current.scrollHeight);
    }
  }, []);
  return (
    <Box id='massivebio-box' sx={{ fontWeight: 'bold', display: 'flex', flexDirection: 'column', alignItems: 'center', height: { xs: '100%', md: '100%', }, width: '100%', overflow: { xs: 'auto', md: 'hidden', }, }}>
      <Typography ref={scrollToTitleRef} variant="h7" sx={{ textAlign: 'center', px: 5, py: 2 }}>Find Cancer Clinical Trials with Expert Help - At No Cost to You</Typography>
      <Typography variant="caption" sx={{ textAlign: 'center', px: 5, mb: 2, fontSize: { xs: 10, sm: 16, md: 18 } }}>Polygon Health has partnered with Massive Bio to help cancer patients access clinical trials based on their personal needs. Massive Bio provides free, personalized support from trial matching through enrollment and beyond.
      </Typography>
      <Divider orientation="horizontal" flexItem />
      <Box ref={BoxBelowTitleRef} id='BoxBelowTitle'
        sx={{
          width: '100%',
          flexGrow: { xs: 0, md: 1 },
          flexShrink: { xs: 0, md: 1 },
          //minHeight: 0, // IMPORTANT: enables child overflow behavior - does not seem to do anything here
          overflowY: { xs: 'hidden', md: 'hidden' }, //md grid items will scroll         
          //height: { xs: 'auto%', md: '100%' }, //md grid items will scroll 
          //border: '10px solid black',
          backgroundColor: 'white',

        }}
      >
        <Grid
          container
          spacing={0}
          sx={{
            overflow: { sm: 'hidden', md: 'hidden' },
            width: '100%',
            height: { xs: '100%', md: '100%' },
            //backgroundColor: 'green'
          }}
        >
          <Grid sx={{
            width: {
              xs: '100%',
              md: '50%',
            }, height: { xs: 'auto', md: '100%' }, overflow: 'auto', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'space-between', px: 2
          }}>
            {!submitted ?
              <ClinicalTrialsSignupForm setSubmitted={() => setSubmitted(true)} scrollUp={() => scrollToTitleRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' })} /> :
              <><ConfirmationCard scrollUp={() => scrollToTitleRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' })} /></>
            }
            <Typography variant='h5' sx={{ textAlign: 'center', marginY: 2, }}>Compliance and Security Certifications</Typography>
            <img src={Certifications} alt="Compliance and Security Certifications" style={{ width: '100%', height: 'auto', }} />
            <Typography variant='h5' sx={{ textAlign: 'center', p: 1, mt: 1 }}>Massive Bio has onboarded over 160,000 cancer patients to find their clinical trial</Typography>
          </Grid>

          <Grid sx={{
            width: {
              xs: '100%',
              md: '50%',
            }, overflow: { xs: 'hidden', md: 'auto' }, height: { xs: 'auto', md: '100%', }, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'space-between', p: 2
          }}>
            {/* <Box sx={{ px: { xs: 3, sm: 3, md: 10, lg: 20, xl: 20 }, h}}> */}
            <HowProcessWorks />
            {!isMdUp && (
              <Button
                variant="contained"
                sx={{
                  mb: 2,
                  backgroundColor: "#5468FF",
                  borderRadius: 10,
                  textTransform: 'none',
                  px: 3
                }}
                onClick={() => {
                  //document.documentElement.scrollTo({ top: 0, behavior: 'smooth' });
                  scrollToTitleRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' }); // <-- Use the ref here
                }}
              >
                {!submitted ? "Sign Up" : "To Top "}
              </Button>
            )}
            <Divider orientation="horizontal" flexItem />

            <NewMultipleMyelomaOptions />
            <Divider orientation="horizontal" flexItem />

            <ClinicalTrialsBenefits />
            <Divider orientation="horizontal" flexItem />
            <DrArturoExplains />
            <Divider orientation="horizontal" flexItem />
            <FAQ />
            <Divider orientation="horizontal" flexItem />
            <AboutMassiveBio />
            {!isMdUp && (
              <Button
                variant="contained"
                sx={{
                  mt: 2,
                  backgroundColor: "#5468FF",
                  borderRadius: 10,
                  textTransform: 'none',
                  px: 3
                }}
                onClick={() => {
                  //document.documentElement.scrollTo({ top: 0, behavior: 'smooth' });
                  scrollToTitleRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' }); // <-- Use the ref here
                }}
              >
                {!submitted ? "Sign Up" : "To Top "}
              </Button>
            )}

          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};



const AboutClinicalTrials: React.FC = () => {
  return (
    <Box>
      {/* What Are Clinical Trials? */}
      <Typography
        variant="h5"
        sx={{
          fontWeight: 'bold',
          mb: 2,
          mt: 4
        }}
      >
        What Are Clinical Trials?
      </Typography>
      <Typography variant="body1" sx={{ fontSize: { xs: 16, sm: 16, md: 18 } }} paragraph>
        A clinical trial is a research study that tests new ways to prevent, detect, or treat diseases like cancer. These trials explore promising treatments such as new medications, procedures, or combinations that are not yet widely available. Participating in a clinical trial gives patients access to cutting-edge care while helping researchers determine how well these new approaches work. Clinical trials are safe, closely monitored by medical professionals, and play a crucial role in improving outcomes for future patients.
      </Typography>

      {/* What You Can Get from a Clinical Trial? */}
      <Typography
        variant="h5"
        sx={{
          fontWeight: 'bold',
          mb: 2,
          mt: 4
        }}
      >
        Why explore a cancer clinical trial?
      </Typography>
      <Grid container spacing={3} sx={{ mb: 4 }}>
        <Grid sx={{
          width: {
            xs: '100%',   // full width on extra-small screens
            sm: '50%',    // half width on small screens and up
          },
        }}>
          <Paper
            elevation={0}
            sx={{
              height: '100%',
              p: 2,
              backgroundColor: '#f8f8f8',
              borderRadius: 1
            }}
          >
            <Typography variant="subtitle1" sx={{ fontWeight: 'bold', fontSize: { xs: 16, sm: 16, md: 18 } }}>
              Access to New Treatments
            </Typography>
            <Typography variant="body2" sx={{ fontSize: { xs: 16, sm: 16, md: 18 } }}>
              Cancer clinical trials offer access to innovative treatments that are not yet widely available, giving patients the chance to benefit from the latest advancements in care.
            </Typography>
          </Paper>
        </Grid>
        <Grid sx={{
          width: {
            xs: '100%',   // full width on extra-small screens
            sm: '50%',    // half width on small screens and up
          },
        }}>
          <Paper
            elevation={0}
            sx={{
              height: '100%',
              p: 2,
              backgroundColor: '#f8f8f8',
              borderRadius: 1
            }}
          >
            <Typography variant="subtitle1" sx={{ fontWeight: 'bold', fontSize: { xs: 16, sm: 16, md: 18 } }}>
              Advancing Research
            </Typography>
            <Typography variant="body2" sx={{ fontSize: { xs: 16, sm: 16, md: 18 } }}>
              Participation not only provides enhanced medical monitoring and support but also plays a vital role in advancing research that could lead to life-saving breakthroughs for others. By joining a trial, you become part of the progress in improving cancer treatment for all.
            </Typography>
          </Paper>
        </Grid>

      </Grid>
    </Box>)
}

{/* <Grid item xs={12} md={4}>
          <Paper
            elevation={0}
            sx={{
              height: '100%',
              p: 2,
              backgroundColor: '#f8f8f8',
              borderRadius: 1
            }}
          >
            <Typography variant="subtitle1" sx={{ fontWeight: 'bold', fontSize: { xs: 16, sm: 16, md: 18 } }}>
              No Cost to Participate
            </Typography>
            <Typography variant="body2" sx={{ fontSize: { xs: 16, sm: 16, md: 18 } }}>
              Massive Bio's services are free for patients, ensuring that financial concerns are not a barrier access to potential treatment options.
            </Typography>
          </Paper>
        </Grid> */}


//export default ClinicalTrialsInfo;
